import { callApi } from '../api/gramjs';
import { SHELL_INFO } from './browser/shellContainer';

let lastReported: string | undefined;

export function reportPushApp(uid: string) {
  const bundleId = SHELL_INFO?.bundleId;
  if (!uid || !bundleId) return;

  const key = `${uid}:${bundleId}`;
  if (key === lastReported) return;
  lastReported = key;

  void callApi('reportPushApp', bundleId).then((result) => {
    if (!result && lastReported === key) {
      lastReported = undefined;
    }
  });
}
